"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Composition_Attester = exports.Composition_AttesterModeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Reference_1 = require("./RTTI_Reference");
var Composition_AttesterModeKind;
(function (Composition_AttesterModeKind) {
    Composition_AttesterModeKind["_personal"] = "personal";
    Composition_AttesterModeKind["_professional"] = "professional";
    Composition_AttesterModeKind["_legal"] = "legal";
    Composition_AttesterModeKind["_official"] = "official";
})(Composition_AttesterModeKind = exports.Composition_AttesterModeKind || (exports.Composition_AttesterModeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Composition_Attester = t.recursion('IComposition_Attester', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        mode: (0, EnumType_1.createEnumType)(Composition_AttesterModeKind, 'Composition_AttesterModeKind'),
        _mode: RTTI_Element_1.RTTI_Element,
        time: RTTI_dateTime_1.RTTI_dateTime,
        _time: RTTI_Element_1.RTTI_Element,
        party: RTTI_Reference_1.RTTI_Reference
    });
});
//# sourceMappingURL=RTTI_Composition_Attester.js.map